<template>
  <SearchRow>
    <Searchcombobox 
      class="cmb" 
      @selectedOption="filterByAnoSemestre" 
      :currentOption="selectedAnoSemestre"
      :options="anoSemestres" />
    <Searchcombobox 
      class="cmb" 
      @selectedOption="filterBy" 
      :currentOption="selectedTipo"
      :options="tipoAtos" />
    <Searchbox @search-word="searchWord" :placeholderText="$t('atos.pesquisa')" />
  </SearchRow>
  <div class="spinnerholder" v-if="isSearching">
    <SpinText :text="$t('apesquisar')" class="spinner" />
  </div>
  <List v-else :listItems="listItems">
    <pagination @changePage="getPage" @loadmore="loadmore" :showPagination="listItems.length > 0"
      :numberOfPages="numberOfPages" :currentPage="currentPage" />
  </List>
  <Nodocs v-if="listItems.length == 0 && !isSearching" />
</template>

<script>
import axios from "@/axios";
import { ref } from 'vue';
import pagination from '@/components/pagination.vue';
import Searchbox from "@/components/search/searchbox.vue";
import SearchRow from "@/components/search/searchRow.vue";
import Searchcombobox from "@/components/searchcombobox.vue";
import List from "@/components/list/list.vue";
import Nodocs from "@/components/nodocs.vue";
import { SpinText } from "umaui";
import { i18n } from "@/main";


export default {
  components: {
    pagination,
    Searchbox,
    SearchRow,
    SpinText,
    List,
    Nodocs,
    Searchcombobox
  },
  setup() {

    const { t } = i18n.global;

    const listItems = ref([]);
    const currentPage = ref(1);
    const pages = ref(0);
    const limit = 10;
    const numberOfPages = ref(0)
    const filter = ref(null);
    const selectedTipo = ref({ label: 'Tipo de Concurso', value: '' });
    const tipoAtos = ref([
      { label: t("atos.tipoato"), value: '' },
      { label: 'Contratações', value: 'contratacoes' },
      { label: 'Renovações', value: 'renovacoes' },
      { label: 'Cessações', value: 'cessacoes' },
      { label: 'Mobilidades', value: 'mobilidades' },
      { label: 'Períodos Experimentais', value: 'periodosexperimentais' },
      { label: 'Licenças Sabáticas', value: 'sabaticas' },
      { label: 'Subidas de Categoria', value: 'subidascat' },
      { label: 'Outros Atos', value: 'outros' },
      { label: 'Licenças Sem Vencimento', value: 'licencasemvencimento' }
    ]);
    const selectedAnoSemestre = ref({ label: 'Tipo de Concurso', value: '' });
    const anoSemestres = ref([]);


    const getPage = (page) => {
      window.scrollTo(0, 0);
      currentPage.value = page;
      fetchDocuments();
    };

    const loadmore = () => {
      currentPage.value = currentPage.value + 1;
      fetchDocuments(true);
    };

    const searchWord = searchfilter => {
      if (searchfilter.length > 2) {
        currentPage.value = 1;
        filter.value = searchfilter;
        fetchDocuments();
      } else {
        currentPage.value = 1;
        filter.value = "";
        fetchDocuments();
      }
    };

    const calculateSearchParameters = () => {
      let params = new URLSearchParams({
        limit: limit,
        offset: (currentPage.value - 1) * limit,
        owner: import.meta.env.VITE_UID,
        publicado: 1,
        sort: "ato_data",
        idioma: i18n.global.locale,
      });
      if (filter.value != null) {
        params.append('filter', filter.value);
      }
      if (selectedTipo.value.value != '') {
        params.append('tipo', selectedTipo.value.value);
      }
      if (selectedAnoSemestre.value.value != '') {
        var yearSem = selectedAnoSemestre.value.value.split(".");
        params.append('anoletivo', yearSem[0]);
        params.append('semestre', `${yearSem[1]}semestre`);
      }
      console.log(params.toString());

      return `?${params.toString()}`;
    }

    const isSearching = ref(true)

    let controller = new AbortController();

    const fetchDocuments = (shouldAdd = false) => {
      if (controller) {
        controller.abort();
      }
      controller = new AbortController();
      isSearching.value = true && !shouldAdd;
      axios.get('/publicitacaoAtos' + calculateSearchParameters(), {
        signal: controller.signal
      })
        .then(resp => {
          const { data, total } = resp.data;
          const formatedData = data.map(el => {
            return {
              ...el,
              doc_ano: el.ato_data.slice(0,4),
              doc_titulo: el.ato_titulo,
              doc_ficheiros:[...el.ato_ficheiros]
            }
          })
          listItems.value = !shouldAdd ? formatedData : [...listItems.value, ...formatedData];
          numberOfPages.value = Math.ceil(total / limit);
          isSearching.value = false;
        })
        .catch(error => {
          if (error.name != "CanceledError") {
            isSearching.value = false;
          }
          console.log(error);
        })
    }

    fetchDocuments()

    const filterBy = selectedOption => {
      selectedTipo.value = selectedOption;
      fetchDocuments()
    }

    const filterByAnoSemestre = selectedOption => {
      selectedAnoSemestre.value = selectedOption;
      fetchDocuments()
    }


    const getTipoAtos = () => {
      axios.get('/tipoatos?idioma=' + i18n.global.locale)
        .then(resp => {
          const { data } = resp;
          data.sort((a, b) => a.ordem - b.ordem);
          tipoAtos.value = [{ label: t("atos.tipoato"), value: '' }, ...data];
        })
        .catch(error => {
          console.log(error);
        });
    }

    getTipoAtos()

    const initAnoSemestreOptions = () => {
      var currentYear = new Date().getFullYear();
      var rows = [];
      for (var i = 2017; i <= currentYear; i++){
        var label = `${i}/${i-1999}`;
        rows.push({value: `${i}.${1}` , label: `${label} - 1º ${t("atos.semestre")}`})
        rows.push({value: `${i}.${2}` , label: `${label} - 2º ${t("atos.semestre")}`})
      }
      rows.push({label: t("atos.anosemestre"), value: ""});
      rows.reverse();
      anoSemestres.value = rows;
    }

    initAnoSemestreOptions()

    return {
      filterByAnoSemestre,
      filterBy,
      selectedTipo,
      selectedAnoSemestre,
      tipoAtos,
      anoSemestres,
      isSearching,
      searchWord,
      listItems,
      currentPage,
      pages,
      getPage,
      loadmore,
      numberOfPages
    };
  }
}
</script>

<style scoped>
.spinnerholder {
  position: relative;
  margin-top: 50px;
}

@media screen and (max-width: 767px) {
  .spinnerholder {
    display: none;
  }

  .cmb {
    display: none;
  }
}
</style>